import React, { useEffect, useState, Fragment} from "react";
import { Link } from "react-router-dom";
import localization from "../../assets/localization/localization";
import Images from "assets/images/imageData";
import "./sidebar.scss";

const SideBar = ({ match, activeComponent, homePermission }) => {
  const [isShowNavLead, setisShowNavLead] = useState(false);
  const [isShowUserRole, setisShowUserRole] = useState(false);
  const [isShowUser, setIsShowUser] = useState(false);
  const [listActive, setListActive] = useState({
    leadLi: false,
    dashboardLi: false,
    partnerLi: false,
    dmsLi: false,
    documentLi: false,
    eSign: false,
    eMudra: false,
    paymentLog: false,
    utr: false,
    role: false,
    user: false,
  });
  const {
    leadLi,
    dashboardLi,
    partnerLi,
    dmsLi,
    documentLi,
    eSign,
    eMudra,
    paymentLog,
    utr,
    role,
    user
  } = listActive;

  const handleSetState = (type) => {
    localStorage.removeItem("sidenav");
    if (type === "lead") {
      setisShowNavLead(!isShowNavLead);
      if (isShowNavLead === false) {
        localStorage.setItem("sidenav", btoa("lead"));
      }
    } else if (type  === "role") {
      console.log('ROLE', isShowUserRole)
      setisShowUserRole(!isShowUserRole);
    } else if (type === "user") {
      setIsShowUser(!isShowUser);
    }
  };

  useEffect(() => {
    (async () => {
      
      const res = await localStorage.getItem("sidenav");
      if (res) {
        const sidenavVal = atob(res);
        if (sidenavVal === "lead") {
          setisShowNavLead(true);
        }
      }
    })();
  });
  useEffect(() => {
    switch (match.path) {
      case "/home":
        setListActive((state) => ({ ...state, dashboardLi: true }));
        break;
      case "/applications":
        setListActive((state) => ({ ...state, leadLi: true }));
        break;
      case "/partners":
        setListActive((state) => ({ ...state, partnerLi: true }));
         break;
      case "/dms":
        setListActive((state) => ({ ...state, dmsLi: true }));
         break;
      case "/documents":
        setListActive((state) => ({ ...state, documentLi: true }));
          break;
      case "/eSign":
        setListActive((state) => ({ ...state, eSign: true}));
        break;
      case "/eMudra":
          setListActive((state) => ({ ...state, eMudra: true}));
          break;
      case "/paymentLog":
        setListActive((state) => ({ ...state, paymentLog: true}));
        break;
      case "/utr":
          setListActive((state) => ({ ...state, utr: true}));
          break;
      case "/role":
        setListActive((state) => ({...state, role: true}));
      case "/user":
          setListActive((state) => ({...state, user: true}));
      default:
        setListActive((state) => ({
          ...state,
          leadLi: false,
          dashboardLi: false,
          partnerLi: false,
          documentLi: false, 
          dmsLi: false,
          eSign: false,
          eMudra: false,
          paymentLog: false,
          utr: false,
          role: false,
          user: false,
        }));
        break;
    }
  }, []);

  const generateMenuOptions = () => {
    let permission = [{"permission_group": "Dashboard", id:"1"}, 
    {"permission_group": "Applications", id:"2"},
    {"permission_group": "Partners", id:"3"}
  ];
    if (homePermission === null || homePermission === undefined) {
      // permission = JSON.parse(sessionStorage.getItem("UserPermission"));
    }
    else {
      permission = homePermission;
    }
    return permission && permission.map((val) => {
      if (val.permission_group === "Dashboard") {
        return (
          <li key={val.id} className={dashboardLi ? "active" : ""}>
            <Link to={`home`}>
              <img src={Images.dashboard} alt="" />
              {localization.dashboard}
            </Link>
          </li>
        );
      }
      if (val.permission_group === "Applications") {
        return (
          <>
            <li style={{display: "none"}} key={val.id+1} className={`treeview nav-li admin-menu ${isShowUserRole ? "dropdown-open" : ""}`}>
              <Link to="#" onClick={() => handleSetState("role")}>
                <img src={Images.group} alt="" />
                {localization.roleManagement}
                <img src={Images?.arrowDown} alt="" className="dropdown-icon" />
              </Link>
              <ul className={`treeview-menu ${isShowUserRole ? "d-block" : ""}`}>
                <li className={role ? "active" : ""}>
                  <Link to="/role">
                  <img src={Images.application} alt="" />
                    {localization.addRole}
                  </Link>
                </li>
              </ul>
            </li>
            <li style={{display: "none"}} key={val.id+2} className={`treeview nav-li admin-menu ${isShowUser ? "dropdown-open" : ""}`}>
              <Link to="#" onClick={() => handleSetState("user")}>
                <img src={Images.group} alt="" />
                {localization.userManagement}
                <img src={Images?.arrowDown} alt="" className="dropdown-icon" />
              </Link>
              <ul className={`treeview-menu ${isShowUser ? "d-block" : ""}`}>
                <li className={user ? "active" : ""}>
                  <Link to="/user">
                  <img src={Images.application} alt="" />
                    {localization.addUser}
                  </Link>
                </li>
              </ul>
            </li>
            <li key={val.id}  className={`treeview nav-li admin-menu ${isShowNavLead ? "dropdown-open" : ""}`}>
              <Link to="#" onClick={() => handleSetState("lead")}>
                <img src={Images.group} alt="" />
                {localization.myLead}
                <img src={Images?.arrowDown} alt="" className="dropdown-icon" />
              </Link>
              <ul className={`treeview-menu ${isShowNavLead ? "d-block" : ""}`}>
                <li className={leadLi ? "active" : ""}>
                  <Link to="/applications">
                  <img src={Images.application} alt="" />
                    {localization.applications}
                  </Link>
                </li>
              </ul>
            </li>
          </>
        );
      }
      if (val.permission_group === "Partners") {
        return (
          <Fragment key={val.id}>
          <li   className={partnerLi ? "active" : ""}>
            <Link to={`/partners`}>
              <img src={Images.partner} alt="" style={{height: '15px', width: '15px', scale: '1.5'}} />
              {localization.partners}
            </Link>
          </li>
          <li className={documentLi ? "active" : ""}>
            <Link to={`/documents`}>
              <img src={Images.document} alt="" />
              {localization.documentCodes}
            </Link>
          </li>
          <li className={dmsLi ? "active" : ""}>
            <Link to={`/dms`}>
              <img src={Images.map} alt="" />
              {localization.dmsMapping}
            </Link>
          </li>
          <li className={eSign ? "active" : ""}>
            <Link to={`/eSign`}>
              <img src={Images.esignBtn} alt="" width="20px" />
              {localization.eSign}
            </Link>
          </li>
          <li className={eMudra ? "active" : ""}>
            <Link to={`/eMudra`}>
              <img src={Images.eMudraBtn} alt="" width="20px" />
              {localization.eMudra}
            </Link>
          </li>
          <li className={paymentLog ? "active" : ""}>
            <Link to={`/paymentLog`}>
              <img src={Images.paymentLog} alt="" width="20px" />
              {localization.paymentLog}
            </Link>
          </li>
          <li className={utr ? "active" : ""}>
            <Link to={`/utr`}>
              <img src={Images.paymentLog} alt="" width="20px" />
              {localization.utr}
            </Link>
          </li>
          </Fragment>
        );
      }

    });
  };
  return (
    <aside className="main-sidebar scrollbar-styling">
      <section className="sidebar">
        <ul className="sidebar-menu tree">
          {generateMenuOptions()}
        </ul>
      </section>
    </aside>
  );
};

export default SideBar;
